export default {"src":"/find-tickets/_next/static/media/bg_vector.20655573.svg","height":426,"width":558,"blurWidth":0,"blurHeight":0};